import React from "react";
import * as Icon from "react-feather";

import "./archive-transactions-modal.css";

import UtilityService from "../../../../services/UtilityService";
import { ARCHIVE_REASONS, ARCHIVE_REASON_OPTIONS } from "../../../../services/BookkeepingService";

import WComponent from "../../../common/WComponent";
import ToolsModal from "../kit/ToolsModal";

const MAXIMUM_ROWS_LISTED = 6;

class ArchiveTransactionsModal extends WComponent {
	constructor(props) {
		super(props);

		this.state = {
			reason: "",
			note: "",
		};
	}

	onReasonSelect = reason => this.update({ reason });

	onNoteChange = event => this.update({ note: event.target.value });

	onArchiveClicked = () => {
		const { reason, note } = this.state;
		if (!reason) return;
		this.props.onConfirm({ reason, note: note.trim() });
	};

	renderTransactionList = () => {
		const { transactions } = this.props;
		const listedTransactions = transactions.slice(0, MAXIMUM_ROWS_LISTED);
		const unlistedCount = transactions.length - listedTransactions.length;

		return (
			<div className="archive-modal__list">
				{listedTransactions.map((transaction, index) => (
					<div key={index} className="archive-modal__row">
						<span className="archive-modal__row-date">{transaction.date || "—"}</span>
						<span className="archive-modal__row-description" title={transaction.description}>{transaction.description}</span>
						<span className="archive-modal__row-amount">{UtilityService.formatCurrency(transaction.amount)}</span>
					</div>
				))}
				{unlistedCount > 0 && <div className="archive-modal__row archive-modal__row--more">and {unlistedCount} more</div>}
			</div>
		);
	};

	renderFooter = () => {
		const { onClose, transactions } = this.props;
		const { reason } = this.state;

		return (
			<>
				<span />
				<span className="tk-modal-actions">
					<button type="button" className="tk-button tk-button--secondary" onClick={onClose}>Cancel</button>
					<button type="button" className="tk-button tk-button--primary" onClick={this.onArchiveClicked} disabled={!reason}>
						<Icon.Archive size={16} />
						Archive {transactions.length} transaction{transactions.length === 1 ? "" : "s"}
					</button>
				</span>
			</>
		);
	};

	render() {
		const { onClose, transactions } = this.props;
		const { reason, note } = this.state;
		const isRemovingRealActivity = reason && reason !== ARCHIVE_REASONS.DUPLICATE && reason !== ARCHIVE_REASONS.NOT_A_TRANSACTION && reason !== ARCHIVE_REASONS.PARSE_ERROR;

		return (
			<ToolsModal open={true} onClose={onClose} title="Archive transactions" width={620} footer={this.renderFooter()}>
				<p className="archive-modal__intro">
					These {transactions.length === 1 ? "transaction leaves" : "transactions leave"} the books — out of the trial balance, the financial statements and every download. Nothing is deleted: {transactions.length === 1 ? "it stays" : "they stay"} under Archived with the reason below and can be restored at any time.
				</p>

				{this.renderTransactionList()}

				<div className="archive-modal__reasons">
					<div className="archive-modal__reasons-label">Why are these leaving the books?</div>
					{ARCHIVE_REASON_OPTIONS.map(option => (
						<label key={option.value} className="archive-modal__reason">
							<input
								type="radio"
								name="archive-reason"
								className="archive-modal__reason-radio"
								checked={reason === option.value}
								onChange={() => this.onReasonSelect(option.value)}
							/>
							{option.label}
						</label>
					))}
				</div>

				{isRemovingRealActivity && (
					<div className="archive-modal__warning">
						<Icon.AlertTriangle size={14} />
						<span>
							If this is genuine bank activity, removing it will stop the bank reconciling to the statement. Archive it only if it does not belong in these books.
						</span>
					</div>
				)}

				<input
					className="tk-input archive-modal__note"
					placeholder="Note (optional)"
					value={note}
					onChange={this.onNoteChange}
					maxLength={255}
				/>
			</ToolsModal>
		);
	}
}

export default ArchiveTransactionsModal;
